import React from 'react'
import styled from 'styled-components'

import TopContent from './Common/TopContent'
import { SAVE_CURATED_TRIP_BUTTON_CLASS } from '../Buttons/SaveCuratedTripItemButton'
import HeadingFullPrint from '../util/HeadingFullPrint'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PrintOnly from 'components/utils/PrintOnly'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import BaseItemCard from 'tripPlanner/components/ItemCard/BaseItemCard'
import ContentWrapper from 'tripPlanner/components/ItemCard/Common/ContentWrapper'
import { ItemImageContainer } from 'tripPlanner/components/ItemCard/ItemImageContainer'
import { ItemMetadata } from 'tripPlanner/models'
import { CarRentalItem } from 'tripPlanner/types/tripItem'
import { formatShortDateRange } from 'tripPlanner/utils'

interface Props {
  item: CarRentalItem
}

const Dates = styled.div`
  display: flex;
  justify-content: space-between;
`

function CarRentalItemCard({ item }: Props) {
  const {
    type,
    companyName,
    carType,
    startPlace,
    startDate,
    endDate,
    startDay,
    endDay,
    confirmationCode,
  } = item

  const { singularName } = ItemMetadata[type]

  return (
    <BaseItemCard item={item}>
      <ItemImageContainer
        item={item}
        name={startPlace.name}
        placeId={'id' in startPlace ? startPlace.id : undefined}
      />
      <ContentWrapper>
        <TopContent item={item}>
          {singularName} {companyName && `• ${companyName}`}
        </TopContent>

        <VerticalSpacer gap={4}>
          {startPlace.region && (
            <BodyText variant="small">{startPlace.region}</BodyText>
          )}
          {carType && (
            <HeadingFullPrint lineClamp={2} variant="heading6">
              {carType}
            </HeadingFullPrint>
          )}
          {confirmationCode && (
            <PrintOnly>
              <BodyText variant="medium">
                <BodyText as="span" variant="medium" weight="bold">
                  Confirmation number:{' '}
                </BodyText>
                {confirmationCode}
              </BodyText>
            </PrintOnly>
          )}
          {startDay && (
            <Dates>
              <div>
                <BodyText variant="medium">
                  {formatShortDateRange({ startDay, endDay })}
                </BodyText>
              </div>
            </Dates>
          )}
          {!startDay && startDate && endDate && (
            <Dates>
              <div>
                <BodyText variant="medium">
                  {formatShortDateRange({
                    startDate,
                    endDate,
                  })}
                </BodyText>
              </div>
            </Dates>
          )}
        </VerticalSpacer>
        <SaveTripItemButton
          className={SAVE_CURATED_TRIP_BUTTON_CLASS}
          item={item}
        />
        {item.startPlace.address && (
          <PrintOnly>
            <BodyTextBlock variant="small" startIcon={<LineMapMarkerIcon />}>
              {item.startPlace.address}
            </BodyTextBlock>
          </PrintOnly>
        )}
        {item.notes && (
          <PrintOnly>
            <BodyText variant="small" weight="normal" wrap="pre-wrap">
              {item.notes}
            </BodyText>
          </PrintOnly>
        )}
      </ContentWrapper>
    </BaseItemCard>
  )
}

export default CarRentalItemCard
